import { BehaviorSubject, Observable, ReplaySubject, Subject, combineLatest } from 'rxjs';
import { SearchCriteria } from '../../../ViewModules/shared-components/ui-search/ui-search.component';
import { CommonUtilty } from './../utilities/commonUtility';
import { Injectable, Inject } from '@angular/core';
import { Http, Headers, Response, Request, RequestOptions, URLSearchParams, RequestMethod } from '@angular/http';
import { TranslateService } from './translate.service';
import { ApiRequestService } from './api-request.service';



@Injectable({
  providedIn: 'root'
})
export class NotesService {

  constructor(
    private apiRequest: ApiRequestService,
    private translate: TranslateService,
    private commonUtilty: CommonUtilty
  ) { }

  getNoteByGuid(guid) {
    let me = this;
    let noteDataSubject = new Subject<any>(); // Will use this subject to emit data that we want
    let pathVariables = [];
    pathVariables.push(guid);
    this.apiRequest.getCallWithAPIMapper('noteFetchByEntityGuid', null, null, pathVariables)
    // this.apiRequest.getCallWithAPIMapper('noteFetchByEntityGuid' + guid)
      .subscribe(jsonResp => {
        let returnObj = jsonResp;
        noteDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
      });

    return noteDataSubject;

  }

  noteSaveSubject$ = new BehaviorSubject(null);

  saveNotes(notesIo): Observable<any> {
    let self = this; //let policyIO = policyIO
    let noteDataSubject = new Subject<any>(); // Will use this subject to emit data that we want after ajax save policy attempt
    this.apiRequest.postCallWithAPIMapper('noteSave', notesIo)
      .subscribe(jsonResp => {
        noteDataSubject.next(jsonResp);

      }, errResp => {
        noteDataSubject.next(errResp);
      })
    return noteDataSubject;
  }

  saveCorrespondence(corIo): Observable<any> {
    let self = this; //let policyIO = policyIO
    let corDataSubject = new Subject<any>(); // Will use this subject to emit data that we want after ajax save policy attempt
    this.apiRequest.postCallWithAPIMapper('corSave', corIo)
        .subscribe(jsonResp => {
          corDataSubject.next(jsonResp);
  
        }, errResp => {
          corDataSubject.next(errResp);
        })
    return corDataSubject;
  }

 saveCorrespondenceMSG(coreMsg): Observable<any> {
  let self = this; //let policyIO = policyIO
  let corDataSubject = new Subject<any>(); // Will use this subject to emit data that we want after ajax save policy attempt
  this.apiRequest.postCallWithAPIMapper('corSaveMessage', coreMsg)
      .subscribe(jsonResp => {
        corDataSubject.next(jsonResp);

      }, errResp => {
        corDataSubject.next(errResp);
      })
  return corDataSubject;
}


  getCorrMsgByGuid(guid): Observable<any> {
    let self = this; //let policyIO = policyIO
    let corDataSubject = new Subject<any>(); // Will use this subject to emit data that we want after ajax save policy attempt
    let IO={
      "guid" : guid
    }
    this.apiRequest.postCallWithAPIMapper('corGetMessageByEntityGuid/', IO)
      .subscribe(jsonResp => {
        let returnObj = jsonResp.correspondenceMsg;
        corDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
      });

    return corDataSubject;
  }

  getTemplateByCode(code) {
    let me = this;
    let templateDataSubject = new Subject<any>(); // Will use this subject to emit data that we want
    let pathVariables = [];
    pathVariables.push(code);
    this.apiRequest.getCallWithAPIMapper('fetchByTemplateCd', null, null, pathVariables)
      .subscribe(jsonResp => {
        let returnObj = jsonResp;
        console.log(returnObj);
        templateDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
      });

    return templateDataSubject;

  }

}
